import React, { useEffect, useState } from "react";
import { Instagram, Facebook, Linkedin, Youtube } from "lucide-react";
import { Link } from "react-router-dom";
import { api } from "../../services/api";

const LOGO = "/logo-kb-icon.png";

const PAGE_LINKS = {
    "Technika": "/technika",
    "Referencie": "/referencie",
    "3D Návrhy": "/vizualizacie",
};

export default function Footer() {
    const scrollTo = (id) =>
        document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });

    const [info, setInfo] = useState({ phone: "", email: "", company: "KB MUSIC s.r.o.", facebook_url: "", instagram_url: "", youtube_url: "" });
    useEffect(() => { api.getSettings().then(d => setInfo(s => ({ ...s, ...d }))).catch(() => {}); }, []);

    return (
        <footer
            className="relative bg-nova-black border-t border-white/5 overflow-hidden"
            data-testid="footer"
        >
            {/* Watermark */}
            <div className="absolute -bottom-16 left-0 right-0 pointer-events-none select-none">
                <div className="font-heading font-black text-[16vw] leading-none text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.04)] text-center">
                    KB MUSIC
                </div>
            </div>

            <div className="relative max-w-7xl mx-auto px-6 sm:px-12 py-20">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-16">
                    <div className="col-span-2">
                        <button
                            onClick={() => scrollTo("#hero")}
                            className="flex items-center gap-3 group"
                            data-testid="footer-logo"
                        >
                            <img
                                src={LOGO}
                                alt="KB MUSIC"
                                className="w-10 h-10 rounded-full object-contain ring-1 ring-nova-cyan/30"
                            />
                            <span className="font-heading font-black text-lg tracking-tight text-white">
                                KB MUSIC
                            </span>
                        </button>
                        <p className="mt-5 text-zinc-400 leading-relaxed max-w-sm text-sm">
                            Profesionálne ozvučenie, osvetlenie a kompletná
                            technická produkcia eventov na Slovensku aj v
                            zahraničí.
                        </p>
                        <div className="mt-6 flex gap-3">
                            {info.instagram_url && (
                                <a href={info.instagram_url} target="_blank" rel="noopener noreferrer"
                                    className="w-10 h-10 rounded-full border border-white/15 bg-nova-surface/60 hover:border-nova-cyan/50 flex items-center justify-center transition-all"
                                    aria-label="Instagram" data-testid="footer-instagram">
                                    <Instagram className="w-4 h-4 text-white" />
                                </a>
                            )}
                            {info.facebook_url && (
                                <a href={info.facebook_url} target="_blank" rel="noopener noreferrer"
                                    className="w-10 h-10 rounded-full border border-white/15 bg-nova-surface/60 hover:border-nova-purple/50 flex items-center justify-center transition-all"
                                    aria-label="Facebook" data-testid="footer-facebook">
                                    <Facebook className="w-4 h-4 text-white" />
                                </a>
                            )}
                            {info.youtube_url && (
                                <a href={info.youtube_url} target="_blank" rel="noopener noreferrer"
                                    className="w-10 h-10 rounded-full border border-white/15 bg-nova-surface/60 hover:border-nova-cyan/50 flex items-center justify-center transition-all"
                                    aria-label="YouTube" data-testid="footer-youtube">
                                    <Youtube className="w-4 h-4 text-white" />
                                </a>
                            )}
                        </div>
                    </div>

                    <div>
                        <h5 className="font-heading font-bold text-white mb-5 text-sm uppercase tracking-wider">
                            Služby
                        </h5>
                        <ul className="space-y-3">
                            {["Ozvučenie eventov", "Osvetlenie", "Prenájom techniky", "Technická produkcia", "LED obrazovky"].map((l) => (
                                <li key={l}>
                                    <button
                                        onClick={() => scrollTo("#services")}
                                        className="text-sm text-zinc-400 hover:text-nova-cyan transition-colors text-left"
                                    >
                                        {l}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h5 className="font-heading font-bold text-white mb-5 text-sm uppercase tracking-wider">
                            Firma
                        </h5>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/o-nas" className="text-sm text-zinc-400 hover:text-nova-cyan transition-colors">
                                    O nás
                                </Link>
                            </li>
                            <li>
                                <button
                                    onClick={() => scrollTo("#gallery")}
                                    className="text-sm text-zinc-400 hover:text-nova-cyan transition-colors text-left"
                                >
                                    Realizácie
                                </button>
                            </li>
                            <li>
                                <Link to="/kontakt" className="text-sm text-zinc-400 hover:text-nova-cyan transition-colors">
                                    Kontakt
                                </Link>
                            </li>
                            {Object.entries(PAGE_LINKS).map(([label, to]) => (
                                <li key={label}>
                                    <Link to={to} className="text-sm text-zinc-400 hover:text-nova-cyan transition-colors">
                                        {label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                        <div className="mt-8 text-sm text-zinc-400 space-y-2">
                            {info.email && <div>{info.email}</div>}
                            {info.phone && <div>{info.phone}</div>}
                        </div>
                        <div className="mt-4 flex gap-3">
                            {info.facebook_url  && <a href={info.facebook_url}  target="_blank" rel="noopener noreferrer" aria-label="Facebook"  className="text-zinc-600 hover:text-white transition-colors"><Facebook  className="w-4 h-4" /></a>}
                            {info.instagram_url && <a href={info.instagram_url} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-zinc-600 hover:text-white transition-colors"><Instagram className="w-4 h-4" /></a>}
                            {info.youtube_url   && <a href={info.youtube_url}   target="_blank" rel="noopener noreferrer" aria-label="YouTube"   className="text-zinc-600 hover:text-white transition-colors"><Youtube   className="w-4 h-4" /></a>}
                        </div>
                    </div>
                </div>

                <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between items-center gap-4">
                    <div className="text-xs text-zinc-600 font-mono">
                        © {new Date().getFullYear()} {info.company || "KB MUSIC s.r.o."} — Všetky práva vyhradené.
                    </div>
                    <div className="text-xs text-zinc-600 font-mono">
                        Made with{" "}
                        <span className="text-nova-cyan">⚡</span> for events that matter
                    </div>
                </div>
            </div>
        </footer>
    );
}
